import { startOfTomorrow } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

export const TEXT_EDITOR_NAME = 'text'
export const DATE_SELECT_NAME = 'date'
export const DATE_SELECT_DEFAULT_VALUE = 'today'
export const DATE_SELECT_PLACEHOLDER = 'Select one'

export const getDateSelectOptions = (t) => [
  {
    label: t('checkIn:note.dateOptions.today'),
    value: 'today',
  },
  {
    label: t('checkIn:note.dateOptions.tomorrow'),
    value: 'tomorrow',
  },
]

export const getSubmitableDateFromSelect = (timezone) => {
  return {
    today: utcToZonedTime(new Date(), timezone),
    tomorrow: utcToZonedTime(startOfTomorrow(new Date()), timezone),
  }
}
